module.exports = __webpack_public_path__ + "static/media/img-epaper-bg-UNSUB-S.e05c6bb6.webp";